<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Loan Products'
    },

    extends: TableView,

    data() {
        const { id: loanShopId } = this.$route.params;

        return {
            loanShop: {},
            loanShopId
        };
    },

    computed: {
        title() {
            return `${this.loanShop.name}'s Loan Products`;
        },

        breadcrumbs() {
            return [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Shops',
                    to: '/loan-shops'
                },
                {
                    text: this.loanShop.name,
                    to: `/loan-shops/${this.loanShop.id}/edit`
                },
                {
                    text: 'Loan Products',
                    active: true
                }
            ];
        },

        labels() {
            return [
                { value: 'name', width: '200px' },
                { value: 'description', width: '400px' },
                {
                    value: 'loanPeriod',
                    width: '200px',
                    type: 'number'
                },
                {
                    value: 'tags',
                    filterFieldName: 'tags.name',
                    width: '150px',
                    sortable: false,
                    filter: v => v.map(tag => tag.name).join(', ')
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.loanShopId
            };
        }
    },

    async created() {
        try {
            this.loanShop = await this.getShop(this.loanShopId);
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getShop: 'loanShops/show',
            getItems: 'loanShops/getProducts',
            deleteItem: 'loanProducts/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(
                `/loan-shops/${this.loanShopId}/loan-products/${id}/edit`
            );
        },
        onAddButtonClick() {
            this.$router.push(
                `/loan-shops/${this.loanShopId}/loan-products/add`
            );
        }
    }
};
</script>
